// src/pages/qc/PageRdCalibrations.jsx
import { useState, useEffect, useMemo } from "react";
import * as api from "../../apiService";
import { fmtDate } from "../../utils/dateUtils";

export function PageRdCalibrations({ myPerms }) {
  const [records,  setRecords]  = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);
  const [search,   setSearch]   = useState("");
  const [typeFilter, setTypeFilter] = useState("ALL");

  useEffect(() => {
    api.fetchAllCalibrations()
      .then(setRecords)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return records.filter(r => {
      const matchType = typeFilter === "ALL" || r.calibrationType === typeFilter;
      const matchQ    = !q ||
        (r.certificateNo || "").toLowerCase().includes(q) ||
        (r.performedBy   || "").toLowerCase().includes(q);
      return matchType && matchQ;
    });
  }, [records, search, typeFilter]);

  return (
    <>
      <div className="page-header">
        <div className="page-header-left">
          <div className="page-title">Calibration Records</div>
          <div className="page-subtitle">Research &amp; Development · All calibration records across all equipment</div>
        </div>
      </div>

      <div className="action-bar" style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
        <input className="form-input" placeholder="Search certificate no, performed by…"
          value={search} onChange={e => setSearch(e.target.value)} style={{ width: 280 }} />
        <select className="form-select" value={typeFilter}
          onChange={e => setTypeFilter(e.target.value)} style={{ width: 180 }}>
          <option value="ALL">All Types</option>
          <option value="INTERNAL">Internal</option>
          <option value="EXTERNAL">External</option>
        </select>
        <span style={{ marginLeft: "auto", fontSize: 12, color: "#6b7280" }}>
          {filtered.length} record{filtered.length !== 1 ? "s" : ""}
        </span>
      </div>

      {loading && <div style={{ color: "#aaa", fontSize: 12 }}>Loading…</div>}
      {error   && <div className="alert-warn">Error: {error}</div>}

      {!loading && !error && (
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Calibration Date</th>
                <th>Equipment</th>
                <th>Type</th>
                <th>Certificate No</th>
                <th>Next Due</th>
                <th>Result</th>
                <th>Performed By</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={8}
                  style={{ textAlign: "center", color: "#aaa", padding: 24 }}>
                  No calibration records found
                </td></tr>
              ) : filtered.map(r => (
                <tr key={r.id}>
                  <td>{fmtDate(r.calibrationDate)}</td>
                  <td className="fw-600">{r.equipmentName}</td>
                  <td style={{ fontSize: 12 }}>{r.calibrationType || "—"}</td>
                  <td style={{ fontFamily: "monospace", fontSize: 12 }}>{r.certificateNo || "—"}</td>
                  <td style={{ fontSize: 12 }}>{r.nextDueDate ? fmtDate(r.nextDueDate) : "—"}</td>
                  <td>
                    <span style={{
                      background: r.result === "PASS" ? "#d1fae5" : "#fee2e2",
                      color:      r.result === "PASS" ? "#065f46" : "#991b1b",
                      borderRadius: 4, padding: "1px 6px", fontSize: 11, fontWeight: 600 }}>
                      {r.result}
                    </span>
                  </td>
                  <td style={{ fontSize: 12 }}>{r.performedBy || "—"}</td>
                  <td style={{ fontSize: 12, maxWidth: 200, overflow: "hidden",
                    textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {r.notes || "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
